module.exports = __webpack_public_path__ + "img/nav-budget-3.b8ee0c7.svg";